<div mat-dialog-content class="main-container aza-pa-dialog-content">
  <div class="aza-pa-flex-column">
    @if (allTeams) {
      <div class="header-container aza-pa-flex-column">
        <div class="header-line header-first-line aza-pa-flex-row">
          <azavista-input-field [field]="nameField" [value]="currentView.name" [editMode]="true"
            [label]="'NAME' | translate" (valueChanged)="onViewNameChanged($event)"
          placeholder="'NAME' | translate"></azavista-input-field>
          @if (data.showUseViewInAllEvents) {
            <mat-checkbox [(ngModel)]="data.useViewInAllEvents"
              [disabled]="true">
              <span translate>USE_VIEW_IN_ALL_EVENTS</span>
            </mat-checkbox>
          }
          <mat-checkbox [(ngModel)]="currentView.shared_view" [disabled]="!isAdmin" color="primary">
            <span translate>SHARE_VIEW_WITH_OTHER_USERS</span>
          </mat-checkbox>
        </div>
        @if (currentView.shared_view) {
          <div class="header-line header-second-line aza-pa-flex-row">
            <mat-checkbox [(ngModel)]="currentView.view_by_all" [disabled]="!isAdmin" color="primary">
              <span translate>SHARE_VIEW_TO_ALL_TEAMS</span>
            </mat-checkbox>
            @if (!currentView.view_by_all) {
              <div class="teams-container aza-pa-flex-row">
                <div class="aza-pa-flex-row aza-pa-no-gap">
                  <azavista-input-field [field]="teamField" [value]="teamFieldValue" [canEdit]="isAdmin"
                    [editMode]="isAdmin" [label]="'TEAM' | translate"
                    (valueChanged)="onTeamValueChanged($event)">
                  </azavista-input-field>
                  <button action="add-team" (click)="onAddTeamClicked()" [disabled]="!isAdmin" mat-icon-button>
                    <mat-icon >add</mat-icon>
                  </button>
                </div>
                @for (team of selectedTeams; track team) {
                  <div class="selected-team-container aza-pa-flex-row aza-pa-no-gap">
                    <span>{{team.name}}</span>
                    <button action="delete-team--id-{{ team.id }}" (click)="onRemoveTeamClicked(team)" [disabled]="!isAdmin" mat-icon-button>
                      <mat-icon color="warn">delete</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div>
          <div>
            <span translate>LINK_THIS_VIEW_TO</span>
          </div>
          @for (fwav of filtersWithAvailableValues; track fwav) {
            <div class="aza-pa-flex-row">
              <mat-form-field>
                <mat-select (selectionChange)="onMultiSelectFieldChanged($event, fwav)"
                  [(value)]="fwav.filter.field_name" placeholder="{{'FIELD' | translate}}">
                  <mat-option value=""></mat-option>
                  @for (field of selectAndMultiSelectFields; track field) {
                    <mat-option [value]="field.id">
                      {{field.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-select [(value)]="fwav.filter.values" multiple placeholder="{{'VALUE' | translate}}">
                  @for (value of fwav.availableValues; track value) {
                    <mat-option [value]="value">
                      {{value}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
      </div>
    }
  </div>
  @if (sectionGroups) {
    <div
      class="sections-and-fields-container aza-pa-two-columns-grid aza-pa-two-columns-grid-full-width-columns">
      <div cdkDropList [cdkDropListData]="sectionGroups"
        class="sections-container aza-pa-flex-column aza-pa-half-padding mat-elevation-z1"
        (cdkDropListDropped)="onSectionDropped($event)">
        @for (sectionGroup of sectionGroups; track sectionGroup; let sectionIndex = $index) {
          <div class="section mat-elevation-z1"
            cdkDrag>
            <div class="section-header aza-pa-grid">
              <div class="aza-pa-flex-row">
                <mat-icon class="grabbable">drag_handle</mat-icon>
                <input [(ngModel)]="sectionGroup.label" matInput placeholder="{{'NAME' | translate}}" />
              </div>
              <div>
                <mat-checkbox [(ngModel)]="sectionGroup.readonly" color="primary"><span
                translate>READ_ONLY</span></mat-checkbox>
              </div>
              <div>
                <button action="delete-section--id-{{ sectionGroup.label }}" (click)="onSectionDeleted(sectionGroup)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="section-columns aza-pa-grid aza-pa-two-columns-grid-full-width-columns aza-pa-flex-item-align-normal">
              <div cdkDropList [cdkDropListData]="sectionGroup.leftFields"
                [id]="'section-' + sectionIndex + '-left-fields'" [cdkDropListConnectedTo]="connectedDropLists"
                (cdkDropListDropped)="onFieldDropped($event)" class="section-column">
                @for (field of sectionGroup.leftFields; track field) {
                  <div cdkDrag class="field aza-pa-padding mat-elevation-z1">
                  {{field.label}}</div>
                }
              </div>
              <div cdkDropList [cdkDropListData]="sectionGroup.rightFields"
                [id]="'section-' + sectionIndex + '-right-fields'" [cdkDropListConnectedTo]="connectedDropLists"
                (cdkDropListDropped)="onFieldDropped($event)" class="section-column">
                @for (field of sectionGroup.rightFields; track field) {
                  <div cdkDrag class="field aza-pa-padding mat-elevation-z1">
                  {{field.label}}</div>
                }
              </div>
            </div>
          </div>
        }
        <div class="sections-actions aza-pa-flex-row aza-pa-content-center">
          <button action="add-section" (click)="onNewSectionAdded()" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <div class="fields-container aza-pa-half-padding mat-elevation-z1">
        <div>
          <mat-form-field>
            <input [(ngModel)]="searchText" matInput placeholder="{{'QUICK_SEARCH' | translate}}" />
          </mat-form-field>
        </div>
        <div cdkDropList [cdkDropListData]="availableFields" id="available-fields-list"
          [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="onFieldDropped($event)"
          class="available-fields-list">
          @for (field of availableFields; track field) {
            <div cdkDrag
              [ngClass]="{'has-filter': !!searchText, 'filtered-by-filter': shouldFilterByFilter(field)}"
              class="field aza-pa-padding mat-elevation-z1">
              {{field.label}}
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
  <azavista-button action="cancel" (click)="onClose()" class="aza-pa-dialog-action-cancel-button"><span
  translate>CANCEL</span></azavista-button>
  <azavista-button action="delete" (click)="onDelete()" [disabled]="!currentView?.id" class="aza-pa-dialog-action-cancel-button"
    color="warn"><span translate>DELETE</span></azavista-button>
    <azavista-button action="save" (click)="onSave()" [disabled]="!canSave" color="primary" class="aza-pa-dialog-action-apply-button">
      <span translate>SAVE</span>
    </azavista-button>
  </div>
